import { makeRootStyles } from "../theme/styles";

const useStyles = makeRootStyles(
  {
    wrapper: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      textAlign: "center",
      gap: "1.5rem",
      marginBottom: "2.5rem",
      padding: "0 24px",
    },
  },
  { name: "ItemSelector" },
);

export { useStyles };
